export enum OrganizationPropertyType {
	BOOLEAN = 'BOOLEAN',
	NUMBER = 'NUMBER',
	STRING = 'STRING',
}
